export const progress = (theme, loading) => ({
    /* Styles applied to the root element. */
    root: {
        height: "calc(100vh - 200px)",
        backgroundImage: "url('" + loading + "')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "200px 200px",
    },
    fullscreen: {},
    hover: {
        position: "fixed",
        width: "100%",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        zIndex: theme.zIndex.modal + 1,
        margin: 0,
    },
    small: {
        height: 70,
        width: 70,
        backgroundSize: "65px 65px",
    },
    medium: {
        height: 100,
        width: 100,
        backgroundSize: "95px 95px",
    },
});
